/**
 * Navigate to companion/setup paths that may include ?query or absolute https URLs.
 * React Router accepts string URLs, but pathname+search is explicit and reliable.
 * External module admin links (SHOP/LOGISTICS/…) must open in a new tab — App embed
 * routes are exact (`/modules/shop`) and deep paths 404.
 */
import { buildExternalModuleEntryUrl } from '../../utils/externalModuleEntry';

export function companionNavigate(navigate, path) {
  const raw = String(path || '').trim();
  if (!raw) return;
  if (/^https?:\/\//i.test(raw)) {
    if (typeof window !== 'undefined') {
      window.open(buildExternalModuleEntryUrl(raw), '_blank', 'noopener,noreferrer');
    }
    return;
  }
  if (typeof navigate !== 'function') return;
  const qi = raw.indexOf('?');
  if (qi === -1) {
    navigate(raw);
    return;
  }
  navigate({
    pathname: raw.slice(0, qi) || '/',
    search: raw.slice(qi),
  });
}

/**
 * True when current location already covers next_action path (pathname + required query).
 * Prevents Guide/Do/sidebar CTAs from looping to the same screen (hang UX).
 * Absolute http(s) targets are never "already here" inside App shell.
 */
export function isNextActionPathActive(pathname, search, targetPath) {
  const raw = String(targetPath || '').trim();
  if (!raw || /^https?:\/\//i.test(raw)) return false;
  const qi = raw.indexOf('?');
  const targetPathname = qi === -1 ? raw : raw.slice(0, qi);
  const targetSearch = qi === -1 ? '' : raw.slice(qi + 1);
  const path = String(pathname || '');
  if (!(path === targetPathname || path.startsWith(`${targetPathname}/`))) return false;
  if (!targetSearch) return true;
  const need = new URLSearchParams(targetSearch);
  const have = new URLSearchParams(String(search || '').replace(/^\?/, ''));
  for (const [key, value] of need.entries()) {
    if (have.get(key) !== value) return false;
  }
  return true;
}
